import { render, staticRenderFns } from "./TheNavbarTopPanelMenuButton.vue?vue&type=template&id=340f0036&scoped=true&"
import script from "./TheNavbarTopPanelMenuButton.vue?vue&type=script&lang=js&"
export * from "./TheNavbarTopPanelMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f0036",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
